import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TranslateIcon from '@mui/icons-material/Translate';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import MicIcon from '@mui/icons-material/Mic';

import CropFreeIcon from '@mui/icons-material/CropFree';
import LayersIcon from '@mui/icons-material/Layers';
import AddchartIcon from '@mui/icons-material/Addchart';

import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';

export const editorLangItStrs = {

    /** Updated at 01.12.2025 */

    /** Updated at 01.12.2025 */
    //Hero component
    chip_label: "Nuovo: Potente Suite di Video Editing AI",
    main_headline_part_1: "Il Tuo Workspace ",
    main_headline_part_2: "Video Cloud",
    main_headline_part_3: "Tutto-in-Uno.",
    main_headline_part_4: "Modifica Tutto. Ovunque.",
    main_subtitles: "Creazione video AI avanzata nel tuo browser: converti da orizzontale a verticale, monta scene automaticamente, traccia i volti e preserva l'identità del parlatore con il doppiaggio AI di nuova generazione.",
    feature_cards: [
        {
            icon: <AutoAwesomeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
            title: "Generatore Virale AI",
            description: "Crea shorts virali con tracciamento facciale da video lunghi in pochi secondi."
          },
          {
            icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
            title: "Doppiaggio e Clonazione Vocale",
            description: "Doppia in oltre 40 lingue mantenendo l'identità vocale originale."
          },
          {
            icon: <TranslateIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
            title: "Sottotitoli Auto & Traduzione",
            description: "Sottotitoli accurati al 99% e traduzione istantanea."
          },
          {
            icon: <AddAPhotoIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
            title: "Suite di IA Generativa",
            description: "Text-to-Speech e generazione immagini AI integrati."
          }
    ],
    start_editing_button: "Inizia a Modificare →",
    ai_dubbing_button: "Prova il Doppiaggio AI (Beta)",
    workspace_preview: "Anteprima Workspace Video",
    //Discover
    discover_ai_shorts_features: [
        {
          icon: <CropFreeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
          title: "Tracciamento Volto AI",
          description: "Il reframing intelligente mantiene il parlatore perfettamente al centro nel formato verticale 9:16."
        },
        {
          icon: <LayersIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Generazione in Batch",
          description: "Carica un video di 60 minuti e ottieni istantaneamente oltre 40 shorts montati e sottotitolati."
        },
        {
          icon: <AddchartIcon fontSize="large" sx={{ color: '#2196F3' }} />,
          title: "Punteggio di Viralità",
          description: "La nostra IA classifica le clip in base al potenziale coinvolgimento per farti pubblicare solo il meglio."
        }
    ],
    discory_label: "⚡ IL MOLTIPLICATORE DI CONTENUTI",
    discovery_left_headline_1: "Un Video Orizzontale.",
    discovery_left_headline_2: "40+ Shorts Virali.",
    disocry_left_headline_3: "Non lasciare che il tuo podcast o i contenuti YouTube prendano polvere. Kedy.ai identifica automaticamente i ganci virali, reinquadra il parlatore attivo e genera clip verticali coinvolgenti in pochi minuti.",
    discovery_CTA_button: "Trasforma 1 Video in 10 Shorts Ora →",
    discovery_video_mockups_1: "SERIE ORIGINALE",
    discovery_video_mockups_2: "La Rivoluzione Tech",
    discovery_video_mockups_3: "S4 • E2",
    discovery_video_mockups_4: "È PAZZESCO! 🤯",

    // Other tools
    other_tools_features: [
        {
          icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Vera Clonazione Vocale",
          description: "Analizziamo la tua impronta vocale unica per creare una versione doppiata che suona esattamente come te."
        },
        {
          icon: <ChatBubbleIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
          title: "Lip Sync Perfetto (Beta)",
          description: "Il video viene sottilmente adattato ai movimenti labiali della nuova lingua per un aspetto naturale."
        },
        {
          icon: <TextIncreaseIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
          title: "Traduzione Contestuale",
          description: "Slang, modi di dire e termini tecnici vengono tradotti accuratamente per mantenere il significato originale."
        }
    ],

    other_tools_right_side_label:"🎙️ STUDIO VOCALE GLOBALE",
    other_tools_headline:"Diventa Globale.",
    speak_local:"Parla Locale.",
    ai_dubbing_explanation: "Abbatti le barriere linguistiche senza perdere la tua identità. Il nostro motore di Doppiaggio AI traduce i tuoi contenuti in oltre 40 lingue preservando voce, emozione e intonazione originali.",
    other_tools_CTA_button: "Clona la Mia Voce e Doppia",
    global_reach_badge_1: "Clonazione Vocale",
    global_reach_badge_2: "Accuratezza del 98%",
    global_reach_badge_3: "Portata Globale",
    global_reach_badge_4: "40+ Lingue Supportate",

    // Social
    social_left_menu_badge: "INTEGRAZIONE PERFETTA",
    social_left_menu_title_1: "Connetti il tuo intero",
    social_left_menu_title_2: "ecosistema creativo.",
    social_left_menu_explanation: "Non perdere tempo a scaricare e ricaricare. Kedy.ai si connette direttamente alle tue piattaforme preferite per la pubblicazione con un clic e la sincronizzazione delle risorse.",
    social_features: [
      {
        title: "Pianificazione intelligente",
        desc: "Pianifica in anticipo. Seleziona date e orari specifici per la pubblicazione dei tuoi contenuti.",
        color: '#22d3ee'
      },
      {
        title: "Caricamento video diretto",
        desc: "Carica filmati 4K direttamente dal tuo dispositivo all'editor cloud.",
        color: '#a78bfa'
      },
      {
        title: "Gestione API sicura",
        desc: "Crittografia di livello aziendale per tutti i tuoi account collegati.",
        color: '#34d399'
      }
    ],
    social_right_menu_title: "Chiavi API e Connessioni",

    // Carousel
    loved_by_creators_1: "Amato dai",
    loved_by_creators_2: "Creator",
    loved_by_creators_3: "Automatizza i flussi di lavoro per i migliori del settore.",
    carousel_button_1: "Inizia gratis",
    carousel_button_2: "Prenota una demo",

    /** Updated at 01.12.2025 */

    "welcomNewProject": "Benvenuti al vostro nuovo progetto",
    "pls_add_media": "Si prega di aggiungere media al vostro progetto",
    "add_video": "Aggiungi Video",
    "add_audio": "Aggiungi Audio",
    "add_image": "Aggiungi Immagine",
    "add_webcam": "Cattura Webcam",
    "add_screen": "Cattura Schermo",
    "add_webcam_screen": "Cattura Webcam & Schermo",
    "capture_screen_camera": "Cattura il tuo schermo & camera!",
    "video_captureDevice": "Dispositivo di Cattura Video",
    "resolution": "Risoluzione",
    "audio_captureDevice": "Dispositivo di Cattura Audio",
    "resize_video": "Ridimensiona Video",
    "rotate_video": "Ruota Video",
    "loop_video": "Loop Video",
    "joinmarge_video": "Aggiungi Unisci/Merge Video",
    "cut_video": "Taglia Video",
    "crop_video": "Ritaglia Video",
    "translate_video": "Traduci Video",
    "transcripbe_video": "Trascrivi Video",
    "auto_subtitles": "Sottotitoli Automatici",
    "add_subtitle_video": "Aggiungi Sottotitolo al Video",
    "compress_video": "Comprimi Video",
    "convert_video": "Converti Video",
    "project_not_accessible": "Progetto non accessibile",
    "continue": 'Continuare',
    "leave": "Lascia",
    "cancel": "Annulla",
    "submit": "Invia",
    "okay": "Ok",
    "stop": "Ferma",
    "record": "Registra",
    "ongoing_upload_project_str": "C'è un caricamento in corso su questo progetto.",
    "leaving_page_sure": "Stai lasciando questa pagina, sei sicuro?",
    "uploading_files": "Caricando File",
    "record_screen_and_upload": "Registra il tuo schermo e carica.",
    "show_defaul_sharingMenu": "Mostra elementi menu condivisione predefiniti",
    "prefer_share_browser": "Preferisci condividere una scheda del browser",
    "prefer_share_window": "Preferisci condividere una finestra",
    "prefer_share_entireScreen": "Preferisci condividere l'intero schermo",
    "record_webcam_and_upload": "Registra la tua webcam e carica.",
    "sign_signup_to_uploadVideos": "Effettua l'accesso o registrati per caricare video",
    "sizelimir_or_timelimit": "più grande di 250 MB o più lungo di 5 minuti",
    "screen_capture_preferences": "Preferenze di Cattura Schermo",
    "is_uploading": "Sta Caricando",
    "monthly": "Mensilmente",
    "annually": "Annuale",
    "most_popular": "Più Popolare",
    "export": "Esporta",
    "bitrate": "Bitrate",
    "frame_rate_fps": "Frame Rate (FPS)",
    "produce": "Produce",
    "setup": "Impostazioni",
    "template": "Modello",
    "templates": "Modelli",
    "media": "Media",
    "stock": "Stock",
    "translations": "Traduzioni",
    "subtitles": "Sottotitoli",
    "text_to_speech": "Da Testo a Voce",
    "transitions": "Transizioni",
    "text": "Testo",
    "emojis": "Emoji",
    "filters": "Filtri",
    "draw": "Disegna",
    "edit_subtitle": "Modifica Sottotitolo",
    "add_new_subtitle": "aggiungi nuovo sottotitolo",
    "select_brush_stock_start_draw": "Seleziona un tratto di pennello per iniziare a disegnare",
    "brush_stroke": "Tratto di Pennello",
    "round": "Rotondo",
    "sliced": "Affettato",
    "color": "Colore",
    "opacity": "Opacità",
    "size": "Dimensione",
    "duration": "Durata",
    "add_new_line": "Aggiungi Nuova Linea",
    "all_types": "Tutti i Tipi",
    "load_more": "Carica Altro",
    "upload_video": "Carica Video",
    "upload_audio": "Carica Audio",
    "upload_image": "Carica Immagine",
    "create_webcam_recording": "Crea Registrazione Webcam",
    "create_screen_capture_recording": "Crea Registrazione di Cattura Schermo",
    "create_webcam_screen_recording": "Crea Registrazione Webcam & Schermo",
    "project_asset": "Asset del Progetto",
    "you_want_add_translations": "Come vuoi aggiungere traduzioni?",
    "uploader": "Uploader",
    "auto": "AUTO",
    "auto_translations": "Traduzioni Automatiche",
    "automatically_add_transllations_video": "Aggiungi automaticamente traduzioni al video",
    "wait_moments_subtitles_being": "Attendi qualche momento mentre il sottotitolo viene preparato",
    "select_language_detect": "Seleziona lingua da rilevare",
    "select_different_target_language": 'Scegli una lingua di destinazione diversa',
    "select_different_source_and_target_languages": 'Le lingue di partenza e di destinazione non possono essere uguali',
    "voice_clones": "Cloni vocali",
    "source_language": "Lingua di partenza",
    "select_source_language": "Seleziona la lingua di origine",
    "select_target_language": "Seleziona la lingua di destinazione",
    "redub_another_language": "Ri-doppiare con un'altra lingua",
    "upload_new_file": 'Carica Nuovo File',
    "no_title": 'Nessun Titolo', 
    "unknown": 'Sconosciuto',
    "watch_video": 'Guarda il Video',
    "listen_audio": 'Ascolta Audio',
    "video_preparing": 'Preparazione del Video',
    "audio_preparing": 'Preparazione dell’Audio',
    "delete_voice_clone": 'Elimina Clone Vocale',
    "delete_voice_clone_assets": 'Elimina Clone Vocale con Asset',
    "no_voice_clones": "Nessun clone vocale da mostrare",  
    "upload_file_to_create_first_voice_clone": "Carica un file per creare il tuo primo clone vocale e abbattere la barriera linguistica",
    "disable_translate": "Disabilita Traduzione",
    "select_language_select": "Seleziona Lingua per tradurre",
    "transition_duration": "Durata Transizione",
    "coming_soon": "Prossimamente",
    "language": "Lingua",
    "english": "Inglese",
    "spanish": "Spagnolo",
    "french": "Francese",
    "german": "Tedesco",
    "italian": "Italiano",
    "portuguese": "Portoghese",
    "polish": "Polacco",
    "turkish": "Turco",
    "russian": "Russo",
    "dutch": "Olandese",
    "czech": "Ceco",
    "arabic": "Arabo",
    "chinese": "Cinese",
    "hungarian": "Ungherese",
    "korean": "Coreano",
    "japanese": "Giapponese",
    "hindi": "Hindi",
    "danish": "Danese",
    "greek": "Greco",
    "finnish": "Finlandese",
    "hebrew": "Ebraico",
    "malay": "Malese",
    "norwegian": "Norvegese",
    "swedish": "Svedese",
    "swahili": "Swahili",
    "speaking_rate_defaul": "Velocità di Parola (default 1)",
    "pitch_defaul": "Tono (default 0)",
    "volume_gain_default": "Guadagno Volume (default 0)",
    "create_text_speech": "Crea Da Testo a Voce",
    "add_text": "Aggiungi Testo",
    "text": "Testo",
    "start": "Inizio",
    "end": "Fine",
    "text_style": "Stile Testo",
    "background_color": "Colore di Sfondo",
    "add_new_text_field": "Aggiungi Nuovo Campo di Testo",
    "how_add_subtitles": "Come vuoi aggiungere sottotitoli",
    "automatically_subtitles_video": "Aggiungi automaticamente sottotitoli al video",
    "text_color": "Colore del Testo",
    "preview_text": "Anteprima Testo",
    "search": "Cerca",
    "orientation": "Orientamento",
    "next": "Prossimo",
    "previous": "Precedente",
    "first": "Primo",  
    "last": "Ultimo",
    "locale": "Locale",
    "landscape": "Paesaggio",
    "portrait": "Ritratto",
    "square": "Quadrato",
    "time": "Tempo",
    "background": "Sfondo",
    "project_setting": "Impostazioni del Progetto",
    "use_template_project": "Usa come progetto modello",
    "visibility": "Visibilità",
    "category": "Categoria",
    "capture_thumbnail": "Cattura Miniatura",
    "brand_kit": "Kit Brand",
    "video_placeholder": "VideoPlaceholder2.mp4",
    "replace_video": "Sostituisci Video",
    "transformations": "Trasformazioni",
    "fill_canvas": "Riempi la tela",
    "fit_canvas": "Adatta alla tela",
    "round_corners": "Angoli Arrotondati",
    "audio": "Audio",
    "detach_audio": "Stacca Audio",
    "cleanAudio": "PulisciAudio",
    "upgrade_basic_unlock": "Aggiorna a BASIC per sbloccare",
    "remove_background_noise_enhance_audio_qty": "Rimuovi rumore di fondo e migliora qualità audio",
    "color_correction": "Correzione Colore",
    "reset": "Reset",
    "exposure": "Esposizione",
    "brightness": "Luminosità",
    "contract": "Contrasto",
    "saturation": "Saturazione",
    "sharpen": "Nitidezza",
    "blur": "Sfocatura",
    "noise": "Rumore",
    "trending": "DI TENDENZA",
    "custom": "PERSONALIZZATO",
    "portrait": "RITRATTO",
    "landscape": "PAESAGGIO",
    "settings": "Impostazioni",
    "magic_draw": "Disegno Magico",
    "tools": "Strumenti",
    "brush_size": "Dimensione Pennello",
    "save": "Salva",
    "clear": "Pulisci",
    "view_all": "Visualizza Tutto",
    "save_your_project_later": "Salva il tuo progetto per dopo",
    "sign_in": "accedi",
    "sign_up": "registrati",
    "sign_up_home": "Registrati",
    "redo": "RIFAI",
    "undo": "ANNULLA",
    "collaborate": "COLLABORA",
    "enter_email_share_project": "Inserisci email per condividere il progetto",
    "share_project": "Condividi Progetto",
    "create_new_workspace": "Crea nuovo Workspace",
    "audio_noise_remove": "Rimozione Rumore Audio",
    "media_upload": "Caricamento Media",
    "draw_color": "Colore Disegno",
    "tsl_none": "nessuno",
    "tsl_fade": "Dissolvenza",
    "tsl_book_flip": "Sfoglia Libro",
    "tsl_disolve": "Dissolvi",
    "tsl_doorway": "Porta",
    "tsl_blur": "Sfocatura",
    "tsl_push": "Spinta",
    "tsl_slide": "Scivolata",
    "tsl_wipe": "Pulizia",
    "tsl_zoom_in": "Zoom Avanti",
    "tsl_zoom_out": "Zoom Indietro",
    "flt_None": "Nessuno",
    "flt_Darker": "Più Scuro",
    "flt_BlacknWhite": "Bianco e Nero",
    "flt_Daphne": "Dafne",
    "flt_Penelope": "Penelope",
    "flt_Phoebe": "Febe",
    "flt_Thalia": "Talia",
    "flt_Chloe": "Cloe",
    "flt_Hermione": "Erminia",
    "flt_Hera": "Era",
    "flt_Rhea": "Rea",
    "flt_Donna": "Donna",
    "flt_Martina": "Martina",
    "flt_Gabriella": "Gabriella",
    "flt_Elisabetta": "Elisabetta",
    "flt_Isabella": "Isabella",
    "flt_Luna": "Luna",
    "flt_Viola": "Viola",
    "flt_Zita": "Zita",
    "flt_Donata": "Donata",
    "flt_Maddalena": "Maddalena",
    "flt_Tecla": "Tecla",
    "flt_Narcisa": "Narcisa",
    "emj_Smileys": "Faccine",
    "emj_Animals": "Animali",
    "emj_People": "Persone",
    "emj_Jobs": "Lavori",
    "emj_Sports": "Sport",
    "emj_Flags": "Bandiere",
    "emj_Signs": "Segnali",
    "emj_Nature": "Natura",
    "emj_Travel": "Viaggi",
    "emj_Letters": "Lettere",
    "emj_Misc": "Varie",
    "create_empty_project_templates": "Crea un Progetto Vuoto dai Modelli",
    "days_ago": "giorni fa", 
    "hours_ago": "ore fa",
    "minutes_ago": "minuti fa",
    "seconds_ago": "secondi fa",
    "create_workspace": "Crea Workspace",
    "workspace": "Workspace",
    "delete_workspace": "Elimina Workspace",
    "transfer_owner": "Trasferisci Proprietario",
    "can_create_new_workspace": "Puoi creare un nuovo workspace?",
    "could_delete_workspace": "Potresti eliminare il workspace?",
    "available_subtitles_time": "Tempo Sottotitoli Disponibile",
    "available_storage_space": "Spazio di Archiviazione Disponibile",
    "other_workspaces": "Altri workspace",
    "members": "Membri",
    "add_member": "Aggiungi Membro",
    "remove_member": "Rimuovi Membro",
    "change_member_level": "Cambia Livello Membro",
    "owner": "Proprietario",
    "admin": "Amministratore",
    "member": "Membro",
    "read_only": "Solo Lettura",
    "duplicate": "Duplica",
    "splite": "Dividi",
    "remove": "rimuovi",
    "layer": "Livello",
    "volume": "Volume",
    "disable": "Disabilita",
    "deleterow": "EliminaRiga",
    "fullscreen": "Schermo Intero",
    "editsubtitle": "ModificaSottotitolo",
    "fit": "Adatta",
    "green_screen": "Schermo Verde",
    "profile": "Profilo",
    "contact_us": "Contattaci",
    "pricing": "Prezzi",
    "login": "Accedi",
    "logout": "Esci",
    "get_started_free": "Inizia - è gratis",
    "dashboard": "Dashboard",
    "projects": "Progetti",
    "menu_Features": "Caratteristiche",
    "menu_Tools": "Strumenti",
    "menu_VideoEditor": "Editor Video",
    "menu_AIVideoEditor": "Editor Video AI",
    "menu_AddImgToVideo": "Aggiungi Immagine al Video",
    "menu_AddMusicToVideo": "Aggiungi Musica al Video",
    "menu_AddTextToVideo": "Aggiungi Testo al Video",
    "menu_FilterVideo": "Filtra Video",
    "menu_AddTransitionstoVideo": "Aggiungi Transizioni al Video",
    "menu_AddFreeStockVideos": "Aggiungi Video di Stock Gratuiti",
    "menu_SubtitlesTranscription": "Sottotitoli & Trascrizione",
    "menu_AddSubtitlesToVideo": "Aggiungi Sottotitoli al Video",
    "menu_AudioToText": "Da Audio a Testo",
    "menu_AutoSubtitles": "Sottotitoli Automatici",
    "menu_TranscribeVideo": "Trascrivi Video",
    "menu_TranslateVideo": "Traduci Video",
    "menu_Toolkit": "Toolkit",
    "menu_Crop": "Ritaglia",
    "menu_Cut": "Taglia",
    "menu_JoinMerge": "Unisci / Merge",
    "menu_LoopVideo": "Loop Video",
    "menu_Resize": "Ridimensiona",
    "menu_Rotate": "Ruota",
    "menu_More": "Altro",
    "menu_VideoCompressor": "Compressore Video",
    "menu_VideoConverter": "Convertitore Video",
    "menu_AIGenerated": "Generato dall’IA",
    "menu_AIGeneratedImages": "Immagini generate dall’IA",
    "menu_AIGeneratedVideos": "Video generati dall’IA",
    "menu_AIGeneratedVoices": "Voci generate dall’IA",
    "menu_Blog": "Blog",
    "menu_VIDEOOBlog": "Blog Kedy.AI",
    "menu_VIDEOOHowTo": "Come fare Kedy.AI",
    "menu_VIDEOOCareers": "Carriere Kedy.AI",
    "try_autosubtitles_in_english": "Prova i sottotitoli automatici in Inglese",
    "try_translations_in_turkish": "Prova le traduzioni in Italiano",
    "try_subtitles_in_spanish": "Prova i sottotitoli in Spagnolo",
    "try_ai_video_summary": "Prova il riassunto video basato su IA",
    "online_ai_video_editor": "Editor Video Online basato su IA",
    "online_could_video_editor": "Editor Video Online basato su Cloud",
    "home_free_trial_detail": 'Prova gratuita di 7 giorni, cancellazione in qualsiasi momento',
    "home_create_button_detail": "Creazione video con un clic con sottotitoli automatici, traduzione, e altro ancora",
    "create_now": "Crea Ora",
    "home_templates_start": "Esplora una gamma di modelli per iniziare",
    "try_now_required": "Provalo ora, non è richiesto alcun account",
    "online_collaborative_video_editing": "Editing Video Collaborativo Online",
    "online_collaborative_video_editing_detail": "Immergiti nel mondo dell'editing video online basato su cloud con kedy.ai. La nostra piattaforma rivoluziona il modo in cui modifichi, offrendo capacità di editing video collaborativo online e uno spazio di lavoro di editing video basato su cloud.",
    "auto_subtitles_translations": "Sottotitoli e Traduzioni Automatici",
    "auto_subtitles_translations_detail": "Arricchisci i tuoi video con la nostra funzionalità di Sottotitoli e Traduzioni Automatici, parte del nostro Software Professionale di Editing Video Online. Progettato per essere uno Strumento di Software di Editing Video per Tutti, kedy.ai rende semplice creare contenuti accessibili e accattivanti.",
    "ai_base_text_speech": "Testo in Voce basato su IA",
    "ai_base_text_speech_detail": "Le nostre Voci di Testo in Parola basate su IA sono perfette per i creatori di contenuti, incarnando il concetto di Editing Video Reinventato per Youtubers e Influencer. Con kedy.ai, trasforma i tuoi script in voiceover coinvolgenti, aggiungendo un tocco professionale ai tuoi video e semplificando il tuo processo di produzione.",
    "free_user_stock_video": "Video di Stock Gratuiti da Utilizzare",
    "free_user_stock_video_detail": "Accedi a una vasta collezione di Video di Stock Gratuiti da Utilizzare con kedy.ai, completando le nostre capacità di Editing Video 4K Online. La nostra piattaforma, essendo un Software di Editing Video 4K per Tutti, assicura che i tuoi progetti si distinguano con metraggio di alta qualità, rendendo l'editing di livello professionale accessibile a tutti gli utenti.",
    "share": "Condividi",
    "unlisted_video": "Video Non Elencato",
    "your_video_about_ready": "Il tuo video sta per essere pronto",
    "hours": "Ore",
    "minutes": "Minuti",
    "seconds": "Secondi",
    "want_free_stuff": "Vuoi roba gratis?",
    "record_screen_webcam_both": "Registra il tuo schermo, webcam, o entrambi",
    "add_subtitle_your_video": "Aggiungi sottotitoli ai tuoi video",
    "create_your_team_workspace": "Crea il tuo Spazio di Lavoro di Squadra",
    "collaborate_videos": "Collabora sui video",
    "generate_transcript": "Genera una trascrizione",
    "singup_get_all_this_more": "Iscriviti (gratis) per ottenere tutto questo e altro ancora!",
    "downloading": "Scaricando",
    "download": "Scarica",
    "reedit_video": "Ri-edita video",
    "remove_watermark": "Rimuovi filigrana",
    "already_have_account": "Hai già un account?",
    "link_copied": "Link Copiato",
    "invitation_list": "Lista Inviti",
    "remove_invitation": "Rimuovi Invito",
    "change_workspace": " Cambia workspace",
    "you_login_manage_your_profile": "Devi accedere per gestire il tuo profilo",
    "you_dont_have_content_here": "Non hai contenuti qui.",
    "name": "Nome",
    "status": "Stato",
    "data_modified": "Data Modificata",
    "all_workspaces": "Tutti gli Workspace",
    "delete_project": "Elimina Progetto",
    "duplicate_project": "Duplica Progetto",
    "draft": "Bozza",
    "edit": "Modifica",
    "surname": "Cognome",
    "email": "Email",
    "plan": "Piano",
    "market_emails": "Email di Marketing",
    "editor_notification": "Notifiche Editor",
    "storage": "Archiviazione",
    "subtitle": "Sottotitolo",
    "delete_account": "Elimina Account",
    "this_action_irreversibe": "Questa azione è irreversibile",
    "current_plan": "PIANO ATTUALE",
    "cancel_subscription": "Annulla Abbonamento",
    "payment_method": "METODI DI PAGAMENTO",
    "expires": "Scade",
    "make_default": "Imposta come Predefinito",
    "delete": "Elimina",
    "add_payment_method": "Aggiungi Metodo di Pagamento",
    "billing_information": "INFORMAZIONI DI FATTURAZIONE",
    "invoice_history": "STORICO FATTURE",
    "payment": "Pagamento",
    "preferences": "Preferenze",
    "save_up_to": "Risparmia Fino a ",
    "your_plan": "Il Tuo Piano",
    "inactive": "Inattivo",
    "contact_sales": "Contatta le Vendite",
    "need_additional_features": "Hai bisogno di funzionalità aggiuntive? Chiedici del nostro piano Enterprise",
    "your_online": 'Il Tuo Editor Online',
    "ai_video_editor": 'Editor Video con IA',
    "one_click_post_production": 'Post-produzione con un clic',
   "screen_and_cam_recorder": 'Registratore Schermo e Camera',
   "subtitle_translation": 'Traduzione Sottotitoli', 
   "subtitles": 'Sottotitoli',
   "corporate_add_ons": 'Componenti Aggiuntivi Aziendali',
   "try_for_free": 'Prova Gratis',
   "workflow_tools": 'Strumenti di Flusso di Lavoro',
   "audio_noise_removal": 'Rimozione Rumore Audio',
   "private_workspaces": 'Workspace Privati',
   "share_and_embed": 'Condividi e Incorpora',
   "video_export_length": "Lunghezza Esportazione Video",
   "the_basics": "Le Basi",
   "support": "Supporto",
   "storage": "Archiviazione",
   "custom_templates":'Modelli Personalizzati',
   "ai_video_editor": 'Editor Video con IA',
   "one_click_post_production": 'Post-produzione con un clic',
   "while_pet_your_cat": 'Mentre accarezzi il tuo gatto / sorseggi il tuo caffè',
   "no_watermark": "Nessun Filigrana",
    "tip_no_watermark": " se il video ha una filigrana o meno",
    "upload_file_size": "Dimensione file caricabile",
    "pricing_compare_header": "Confronta i pacchetti",
    "pricing_all_plans_description":"Tutti i piani includono tutte le funzionalità di editing video, sottotitoli automatici, progetti illimitati ed esportazioni illimitate",
    "pricing_apply_coupon": "Applica coupon",
    "pricing_faq_header": "Domande frequenti",
    "upload_file_size_tip": "La dimensione massima del file che puoi caricare",
    "upload_file_size_unlimited": "Dimensione file caricabile – illimitata",
    "export_quality_1080p": "Qualità di esportazione – 1080p",
    "video_export_length_tip": "La durata massima del video che puoi esportare",
    "video_export_length_free": "10 minuti",
    "video_export_length_basic": "25 minuti",
    "video_export_length_pro": "2 ore",
    "video_export_length_business": "2 ore",
    "integrations": 'Integrazioni',
    "video_player": 'Lettore Video',
    "video_compressor_basic":  'Compressore Video Basic',
    "video_compressor_pro": 'Compressore Video Pro',
    "video_compressor_max": 'Compressore Video Max',
    "video_compressor_premium": 'Compressore Video Premium',
    "convert_video_basic": 'Convertitore Video Basic',
    "convert_video_pro": 'Convertitore Video Pro',
    "convert_video_max": 'Convertitore Video Max',
    "convert_video_premium": 'Convertitore Video Premium',
    "video_compressor": 'Compressore Video',
    "custom_privacy_and_security": 'Privacy e Sicurezza Personalizzate',
    "while_pet_your_cat":'Mentre accarezzi il tuo gatto / sorseggi il tuo caffè',
    "no_sign_up_required": 'Nessuna registrazione richiesta',
    "your_online_ai_video_editor": 'Il Tuo Editor Video con IA Online',
    "discover_kedy": "Scopri gli strumenti con IA di Kedy.AI!",
    "create_video_summaries": "Crea riepiloghi video con l’IA",
    "video_summary_description": "Kedy.AI crea sezioni chiave da video lunghi con titoli, descrizioni e download facili—veloce e senza sforzo.",
    "ai_video_dubbing": "Abbatti le barriere linguistiche con il doppiaggio IA",
    "ai_video_dubbing_description": "Lo strumento di doppiaggio di Kedy.AI ti permette di parlare qualsiasi lingua—mantenendo la tua voce. Carica un video, l’IA fa il resto.",
    "ai_shorts_reels_generator": "Generatore di Shorts/Reels con IA",
    "select_options_to_create_shorts": "Seleziona le opzioni per creare video Shorts/Reels con IA.",
    "select_ai_shorts_options": "Seleziona opzioni Shorts IA",
    "summarize_your_content_in": "Riepiloga il tuo contenuto in . . .",
    "set_silence_threshold": "Imposta la soglia di silenzio (in secondi):",
    "more_chapters": "Più capitoli",
    "less_chapters": "Meno capitoli",
    "set_min_clip_duration": "Imposta la durata minima del clip (in secondi):",
    "set_num_of_chapters": "Imposta il numero totale di capitoli:",
    "viral_clips": "Crea clip virali con il generatore virale IA per i social",
    "viral_clips_description": "Trasforma qualsiasi video in clip virali accattivanti con la magia di Kedy.AI—focus intelligente sui volti, sottotitoli evidenziati e contenuti pronti da condividere.",
    "kedy_ai_editor": "L’editor di Kedy.AI ha tutto ciò di cui hai bisogno",
    "kedy_offers_essential_video_editor_tools": "Kedy.AI offre tutti gli strumenti essenziali di un editor video",
    "create_project": "Crea Progetto",
    "other_ai_tools": "Altri strumenti moderni con IA",
    "ai_generated_subtitles": "Sottotitoli automatici generati dall’IA",
    "ai_translation": "Traduzione con IA",
    "ai_text_to_speech": "Da testo a voce",
    "ai_generated_images": "Immagini generate con IA",
    "finish_post_production": "Completa la post-produzione con pochi clic!",
    "try_now": "Prova ora"

}
